import { render } from "./PostAdministatorShortCard.vue?vue&type=template&id=67a28a42"
import script from "./PostAdministatorShortCard.vue?vue&type=script&lang=js"
export * from "./PostAdministatorShortCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__